import styles from './FJRecordDevice.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJArrowBottomIcon from '../../../../assets/svg/button-pull-down.svg?react';
import FJChooseIcon from '../../../../assets/svg/choose.svg?react';
import classNames from 'classnames';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJRecorderFrequencyContainer from '../container/FJRecorderFrequencyContainer.jsx';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';
const FJRecordDevice = props => {
    const { list = [], id, onClick, onClickRecorder } = props;
    const dropRef = useRef(null);

    const obj = list.find(item => {
        return item.id === id;
    });
    const showName = obj ? FJLocalStore._(obj.text) : '';

    /**
     * @description 选中item
     * @param value
     * @private
     */
    const _onClick = value => {
        if (id !== value) {
            onClick && onClick(value);
        }
        dropRef.current.hide();
    };

    const _onRecorderBtnClick = () => {
        onClickRecorder();
    };

    const _renderTrigger = config => {
        return (
            <div className={styles.trigger_box} onClick={config.onClick} ref={config.ref}>
                <div className={styles.text}>{showName}</div>
                <FJArrowBottomIcon />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.detail_box} ref={config.ref}>
                <FJVerticalScroller style={{ height: '100%' }}>
                    {list.map(item => {
                        const disabled = item.active !== undefined ? !item.active : false;
                        return (
                            <div
                                key={item.id}
                                className={classNames(styles.item, disabled ? styles.item_disabled : '')}
                                onClick={_onClick.bind(null, item.id, disabled)}
                            >
                                <div className={styles.item_main}>
                                    {FJLocalStore._(item.text)}
                                    {item.id === id ? <FJChooseIcon /> : null}
                                </div>
                            </div>
                        );
                    })}
                </FJVerticalScroller>
            </div>
        );
    };

    return (
        <div className={styles.box}>
            <div
                className={styles.record_desc}
                dangerouslySetInnerHTML={{
                    __html: FJLocalStore._('you-can-stop-after-15s-and-can-be-recorded-up-to-3min'),
                }}
            />
            <div className={styles.device_title}>{FJLocalStore._('recording-device')}</div>
            <FJDropdownNew
                renderTrigger={_renderTrigger}
                placement='bottomCenter'
                triggerDisplay='flex'
                renderOverlay={_renderOverlay}
                zIndex={1001}
                offsetTop={4}
                ref={dropRef}
            />
            <FJRecorderFrequencyContainer />
            <FJToolTip title='start-recording'>
                <div className={styles.recorder_btn} onClick={_onRecorderBtnClick}>
                    <span className={classNames(styles.btn_inner)} />
                </div>
            </FJToolTip>
        </div>
    );
};

FJRecordDevice.propTypes = {
    list: PropTypes.array,
    id: PropTypes.string,
    onClick: PropTypes.func,
    onClickRecorder: PropTypes.func,
};
export default FJRecordDevice;
